import { CAFPlayerOptions, ClientPlatform } from '@tv2-player/unifiedplayer/src/types';
import { version } from '../../release.json';
import { isDev } from '../utils/env';
import { deviceDetector } from '../utils/deviceDetector';
import endpoints from './endpoints';

export function getPlayerConfiguration(): CAFPlayerOptions {
  const marketingCloudId = '86CA2B31536B6DE60A490D4C@AdobeOrg';

  return {
    npaw: {
      accountCode: isDev ? 'tv2dkdev' : 'tv2dk',
      isDev,
    },
    nielsen: {
      appId: 'PB031036E-347A-4C75-8B59-39D5916190AF',
      instanceName: 'nSdkInstanceTv2',
    },
    yospace: {
      extendInfo: {},
    },
    adobe: {
      marketingCloud: {
        org: marketingCloudId,
      },
      analytics: {
        rsids: isDev ? 'tv2dev' : 'tv2prod',
        server: 'tv2.sc.omtrdc.net',
        ssl: true,
        offlineEnabled: false,
        charset: 'utf-8',
        privacyDefault: 'optedin',
        timezone: 'CEST',
        timezoneOffset: 120,
      },
      mediaHeartbeat: {
        server: 'tv2.hb-api.omtrdc.net',
        publisher: marketingCloudId,
        ssl: true,
        ovp: 'mpx',
      },
    },
    clientPlatform: {
      name: 'Chromecast',
      audience: 'PLAY',
      class: deviceDetector(),
      version,
    } as ClientPlatform,
    epgEndpoint: endpoints.api,
  };
}
